import { PageLayout } from "../components/PageLayout";
import { TransferBalance } from "../features/transferBalance/TransferBalance";

export const TransferBalancePage: React.FC = () => {
  return <PageLayout>
    <TransferBalance />
  </PageLayout>;
};